import React, { useState, useEffect } from 'react';
import ThemeBtn from './components/ThemeBtn';
import Lector from './view/Lector';
import Generador from './view/Generador';
import Attribution from './components/Attribution';


function App() {
	const [isQRGenerated, setIsQRGenerated] = useState(false);

	const handleButtonClick = () => {
		setIsQRGenerated(!isQRGenerated);
	};

	const Login = async () => {
		window.open("https://accounts.codeflex.com.co/" , "_top")
	};

	const headerContent = (
		<div style={{
			background: '#99A3A4',
			color: "#FDFEFE",
			padding: '20px',
			margin: '0 auto',
			maxWidth: '100%',
		}}>
			<p><strong>¡Codeflex QR!</strong></p>
			<p>Aquí puedes generar y leer códigos QR para diferentes tipos de contenido,<br/> Lo que te brinda diversas opciones y posibilidades.<br/> Algunas de las características clave de nuestra página incluyen:</p>
			<ul>
				<li>Generación de códigos QR para texto, URL (http y https),<br/> Wi-Fi, enlaces de WhatsApp, SMS, teléfono y correo electrónico.</li>
				<li>Funcionalidad de lectura de códigos QR a través de la cámara de tu dispositivo.</li>
				<li>Generación de códigos QR para PDF, imágenes y videos (requiere inicio de sesión).</li>
			</ul>
		</div>
	);

	return (
		<>
			<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<button
					style={{
						cursor: 'pointer',
						width: '54%',
						borderRadius: '1%', 
						fontSize: '20px',
						color: isQRGenerated ? '#000000' : '#000000',
						background: isQRGenerated ? '#1CA3D6' : 'orange',
					}} 
					onClick={handleButtonClick}
				>
					<span>{isQRGenerated ? 'Generar QR' : 'Escanear QR'}</span>
				</button>
				&nbsp;&nbsp;
				<button
					style={{
						cursor: 'pointer',
						width: '28%',
						borderRadius: '1%',
						fontSize: '20px',
						color:'#000000',
						background:'#38D61C',
					}} 
					onClick={Login}
				>
					<span>Login</span>
				</button>
				
			</div>
			{isQRGenerated ? 
			<></>
			: 
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					{headerContent}
				</div>	
			}
			<br/>
			<header>
				<ThemeBtn />
			</header>
			{isQRGenerated ? <Lector /> : <Generador/>}
			<Attribution/>
		</>
	);
}

export default App;
